import React, { Component, ReactNode, useState } from 'react';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';
import { injectIntl } from 'react-intl';
import {
  Popover,
  TextField,
  ResourceList
} from '@superops/ui-design-system';
import { clone } from 'lodash';
import { getTranslatedText, Loader } from '@nile/components';

interface Tech {
  name: string;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
}
interface SearchDropdownProps {
  intl: any;
  currentValues: Tech[];
  updateValues?: Function;
  allowTagAddition: Boolean;
  activator: Component;
  listItems: Array<Tech>;
  loading: Boolean;
  error: any;
  getItemsList: Function;
  editDisabled: Boolean;
  RenderItem: ReactNode;
  hoverBg: string;
}

const SearchHolder = styled.div`
  padding: 0 6px;
  .Superops-TextField--sizeSmall {
    width: 100%;
  }
`;

const ResourceListContainer = styled.div`
  padding: 0 6px;
  height: calc(100% - 50px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    positiom: absolute;
    right: 0;
  }
`;

const SpanSpace = styled.span`
  ${(props: { inactive: Boolean }) =>
    props.inactive === true &&
    `
        opacity: 0.5;
        cursor: default;
        pointer-events: none;
    `}
`;

const SearchDropDownContianer = styled.div`
  width: 260px;
  height: 300px;
  .Superops-ResourceItem__Container{
    border-radius: 5px;
    &:hover {
      background: ${props => props.hoverBg ? props.hoverBg : ''};
    }
  }
  .Superops-ResourceItem--gutterMd {
    padding: 8px 10px !important;
  }
`

const MAX_TAG_LIMIT = 10;

function SearchDropdown({
  intl,
  currentValues,
  updateValues,
  activator,
  listItems,
  loading,
  error,
  RenderItem,
  hoverBg
}: SearchDropdownProps) {
  const [active, setActive] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const limitAddTag = currentValues && currentValues.length >= MAX_TAG_LIMIT;

  const handleItemSelect = (tech: Tech) => {
    const selectedTags = currentValues && currentValues.length > 0 ? clone(currentValues) : [];
    selectedTags.push(tech);

    if (updateValues && !limitAddTag) {
      updateValues(selectedTags);
      setActive(false)
    }
  };

  const renderItem = (item: Tech) => {
    return (
      <ResourceList.Item id={item.userId} onClick={() => handleItemSelect(item)}>
        <RenderItem item={item} />
      </ResourceList.Item>
    );
  };

  const getListItems = () => {
    const clonedListItems = clone(listItems);
    return clonedListItems.filter((item: Tech) => {
      const displayVal = item.name || `${item.firstName}, ${item.lastName}`;
      return displayVal.toLowerCase().includes(searchValue.toLowerCase());
    });
  };

  return (
    <div className="flex actr wrap">
      <SpanSpace inactive={limitAddTag}>
        <Popover
          active={active}
          activator={
            <div
              id={'communityScriptAddTag'}
              onClick={() => setActive(!active)}>
              {activator}
            </div>
          }
          preferredAlignment='left'
          preferredPosition='below'
          onClose={() => setActive(!active)}
          fullHeight
        >
          <SearchDropDownContianer hoverBg={hoverBg} >
            <SearchHolder>
              <TextField
                variant="outline"
                size="small"
                value={searchValue}
                autoComplete='off'
                onChange={(word) => setSearchValue(word)}
                placeholder={getTranslatedText(intl, 'ticket.icon.search')}
                prefix={<SVGIcon name="Search" color='#00000040' />}
              />
            </SearchHolder>
            <ResourceListContainer>
              {!error ? loading ? <Loader /> : <ResourceList items={getListItems()} renderItem={renderItem} emptyState={<ResourceList.Item>{getTranslatedText(intl, 'app.general.noData')}</ResourceList.Item>} /> : <div>{getTranslatedText(intl, 'app.general.toast.error')}</div>}
            </ResourceListContainer>
          </SearchDropDownContianer>
        </Popover>
      </SpanSpace>
    </div>
  );
}

export default injectIntl(SearchDropdown);
